module.exports = __webpack_public_path__ + "static/media/support.27ac2e35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/support.svg
// module id = 1315
// module chunks = 49